export const profile = {
  name: "饭`Fantety",
  slogan: "记得好好吃饭",
  intro: "把灵感装进饭盒，挂在风里慢慢晃。",
  socialLinks: [
    {
      label: "B站",
      href: "https://space.bilibili.com/87643009",
    },
    {
      label: "GitHub",
      href: "https://github.com/Fantety",
    },
  ],
};

export const galleryImages = [
  {
    src: "/images/1.png",
    alt: "这是新的饭饭",
    caption: "青柠电波便当",
  },
  {
    src: "/images/2.png",
    alt: "有点旧的饭饭",
    caption: "莓子步行饭团",
  },
  {
    src: "/images/3.png",
    alt: "夏日清爽饭饭",
    caption: "海盐星星乌冬",
  },
];

export const projects = [
  {
    title: "GDBLE",
    status: "GitHub 仓库",
    description:
      "GDBLE 是一个为 Godot 4 设计的蓝牙低功耗（BLE）插件，使用 Rust 和 GDExtension 构建。它基于 btleplug 库，提供了完整的 BLE 功能，包括设备扫描、连接、服务发现、特征读写和通知订阅。",
    href: "https://github.com/Fantety/GDBLE",
  },
  {
    title: "PixTXT",
    status: "GitHub 仓库",
    description:
      "PixTXT 是一种面向像素画的文本格式，强调人类可读、低 token 成本以及稳定的 LLM 生成效果。",
    href: "https://github.com/Fantety/PixTXT",
  },
  {
    title: "GDBlive",
    status: "GitHub 仓库",
    description:
      "GDBLive - B站直播开放平台 Godot 插件，让你的 Godot 游戏轻松接入 B站直播互动功能 ",
    href: "https://github.com/Fantety/GDBlive",
  },
];
